import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-model',
  templateUrl: './model.component.html'
})
export class ModelComponent {
  constructor() {}
}
